import "./WhatWeDo.scss";
import WhatWeDoContent from "./WhatWeDoContent";
import data from "./whatWeDo.json";

export default function WhatWeDo() {
  const whatWeDoData = data.data;
  const paragraph_title = data.paragraph_title;

  return (
    <div className="whatwedo-container">
      <WhatWeDoContent
        whatWeDoData={whatWeDoData}
        paragraph_title={paragraph_title}
      />
    </div>
  );
}
